// extracted by mini-css-extract-plugin
export default {"scrollbar-wrapper":"EhGBii","scrollbarWrapper":"EhGBii"};